import React from "react";
import RedirectingPage from "./RedirectingPage";

const Talleres = () => (
  <RedirectingPage url="https://app.copywriteeducacion.com/public/forms/homework" />
);

export default Talleres;
